export default __webpack_public_path__ + "static/media/glassesApp.60f3be77.png";